module.exports = __webpack_public_path__ + "media/images/client-wren-d80ae1ad6b3053f887917f7c6ab352ef.svg";